import React from 'react';
import { IActivityRenderer } from './interfaces';
import { ActivityComponentMap } from '../ActivityComponentMap';
import dayjs from 'dayjs';

export const ActivityRenderer: React.FC<IActivityRenderer> = ({
  activity,
}): JSX.Element | null => {
  const Component = ActivityComponentMap[activity.type];

  if (!Component) {
    return null;
  }

  return <Component {...activity.data} date={dayjs(activity.date)} />;
};
